/* eslint-disable @typescript-eslint/camelcase */
import { isEmpty } from 'lodash'
import { IPriceConfiguration } from '../index'

export default function(values: IPriceConfiguration, objectId, calendarId) {
  return {
    id_calendar: calendarId,
    id_object: objectId,
    taxes: values.localTax
      ? values.kids_tax
          .map(kid => {
            return (kid.ageTo !== undefined && kid.ageFrom !== undefined) ||
              kid.deleted
              ? {
                  age_from: Number(kid.ageFrom),
                  age_to: Number(kid.ageTo),
                  taxes: kid.taxes,
                  deleted: kid.deleted,
                  id: Number(kid.id) ? Number(kid.id) : undefined,
                }
              : {}
          })
          .filter(item => !isEmpty(item))
      : isEmpty(values.kids_tax[0])
      ? []
      : values.kids_tax
          .map(kid => {
            return kid.ageTo !== undefined && kid.ageFrom !== undefined
              ? {
                  age_from: Number(kid.ageFrom),
                  age_to: Number(kid.ageTo),
                  taxes: kid.taxes,
                  deleted: 1,
                  food_discount: 0,
                  id: Number(kid.id) ? Number(kid.id) : undefined,
                }
              : {}
          })
          .filter(item => !isEmpty(item)),
  }
}
